import { useCallback } from "react";

export const createInitialPriceFilter = () => ({
  value: "",
});

export default function usePriceFilterInSearchFilters({
  setSearchFilters,
  fallbackPriceFilter,
}) {
  const setPriceFilterInSearchFilters = useCallback(
    (nextPriceFilterOrUpdater) => {
      setSearchFilters((previousFilters) => {
        const previousPriceFilter =
          previousFilters.priceFilter ?? fallbackPriceFilter;

        const nextPriceFilter =
          typeof nextPriceFilterOrUpdater === "function"
            ? nextPriceFilterOrUpdater(previousPriceFilter)
            : nextPriceFilterOrUpdater;

        return {
          ...previousFilters,
          priceFilter: nextPriceFilter,
        };
      });
    },
    [setSearchFilters, fallbackPriceFilter]
  );

  return { setPriceFilterInSearchFilters };
}